var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2977 13.4499L15.5578 13.1371C14.8998 13.0615 14.2525 13.2881 13.7887 13.7519L11.8038 15.7368C8.75108 14.1834 6.24845 11.6916 4.6951 8.62802L6.69073 6.63239C7.15457 6.16854 7.3811 5.52131 7.30559 4.86329L6.99277 2.14493C6.86332 1.05542 5.94641 0.235596 4.84612 0.235596H2.97994C1.76099 0.235596 0.746995 1.24959 0.822505 2.46854C1.39423 11.6808 8.76186 19.0376 17.9633 19.6094C19.1823 19.6849 20.1963 18.6709 20.1963 17.4519V15.5857C20.2071 14.4962 19.3872 13.5793 18.2977 13.4499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.02f4c620ce7a6b337c8462127ba26dc8.svg";
export { ForwardRef as ReactComponent };